const replaceExtension = (fileName, extension) =>
  fileName.replace(/\.[^.]+$/, `.${extension}`)

const createContextResolver = (context) => (fileName) => {
  try {
    return context(`./${fileName}`)
  } catch (error) {
    return null
  }
}

const createOptimizedImageSource = (resolveAsset, fileName) => ({
  src: resolveAsset(fileName),
  sources: [
    (() => {
      const srcset = resolveAsset(replaceExtension(fileName, "avif"))
      return srcset ? { srcset, type: "image/avif" } : null
    })(),
    (() => {
      const srcset = resolveAsset(replaceExtension(fileName, "webp"))
      return srcset ? { srcset, type: "image/webp" } : null
    })(),
  ].filter(Boolean),
})

const createImageMap = (entries, resolveAsset) => Object.freeze(Object.fromEntries(
  entries.map(([key, fileName]) => [key, createOptimizedImageSource(resolveAsset, fileName)]),
))

const createSequentialEntries = (prefix, total, extension = "png") =>
  Array.from({ length: total }, (_, index) => [prefix + (index + 1), `${index + 1}.${extension}`])

const homeGuideEntries = [
  ...createSequentialEntries("docImg", 126),
  ["customerTag1", "customer_tag_1.png"],
  ["customerTag2", "customer_tag_2.png"],
  ["customerTag3", "customer_tag_3.png"],
  ["partImag6_1", "part_6_1.png"],
  ["partImag6_2", "part_6_2.png"],
  ["partImag6_3", "part_6_3.png"],
  ["partImag6_4", "part_6_4.png"],
  ["partImag6_5", "part_6_5.png"],
  ["partImag6_6", "part_6_6.png"],
  ["P3_1", "p3_1.png"],
  ["P3_2", "p3_2.png"],
  ["P3_3", "p3_3.png"],
  ["P3_4", "p3_4.png"],
  ["P3_5", "p3_5.png"],
  ["P3_6", "p3_6.png"],
  ["P3_7", "p3_7.png"],
  ["P3_8", "p3_8.png"],
  ["P3_9", "p3_9.png"],
  ["P3_10", "p3_10.png"],
  ["P3_11", "p3_11.png"],
  ["P3_12", "p3_12.png"],
  ["P3_13", "p3_13.png"],
  ["P3_14", "p3_14.png"],
]

const settingGuideEntries = createSequentialEntries("image", 22)
  .map(([key, indexFileName]) => {
    const index = indexFileName.replace(/\.png$/, "")
    return [key, `image (${index}).png`]
  })

const resolveDocGuideAsset = createContextResolver(
  require.context("../../../assets/docimg", false, /\.(png|jpe?g|webp|avif)$/),
)

const resolveSettingGuideAsset = createContextResolver(
  require.context("../../../assets/settingGuideImg", false, /\.(png|jpe?g|webp|avif)$/),
)

export const homeGuideImages = createImageMap(homeGuideEntries, resolveDocGuideAsset)
export const settingGuideImages = createImageMap(settingGuideEntries, resolveSettingGuideAsset)
